import { useRef } from "react";
import "./style.css";
export const EditorSections = ({ sections }) => {
  const content = useRef(null);
  const jump = (id) => {
    const section = content.current?.querySelector(
      `[data-editor-section="${id}"]`,
    );
    section?.scrollIntoView({ block: "start", behavior: "smooth" });
    section?.querySelector("h3")?.focus({ preventScroll: true });
  };
  return (
    <div className="editorSections">
      <nav aria-label="Secciones de la ficha">
        <span>SECCIONES</span>
        {sections.map((section) => (
          <button
            key={section.id}
            type="button"
            onClick={() => jump(section.id)}
          >
            {section.navTitle || section.title}
          </button>
        ))}
      </nav>
      <div ref={content} className="editorSectionsContent">
        {sections.map((section) => (
          <section
            className="adminPanel"
            data-editor-section={section.id}
            key={section.id}
          >
            <header>
              <h3 tabIndex={-1}>{section.title}</h3>
              {section.description && <p>{section.description}</p>}
            </header>
            <div className="editorSectionFields">{section.content}</div>
          </section>
        ))}
      </div>
    </div>
  );
};
